/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-vars */
import { useMediaQuery } from "beautiful-react-hooks";
import React, { useMemo, useState } from "react";
import { Trans } from "@lingui/macro";
import Button from "../../../components/Button";
import { isSSR } from "../../../components/NoSSR";
import Popup from "../../../components/Popup";
import places from "../assets/places.svg";

import "./ErrorPopup.css";
import { getBaseUrl } from "../../../functions/getBaseUrl";
import sendEvent from "../../../functions/analytics";

export function ErrorPopup({ theme = "no-route", onClickPrev }) {
  const isMobile = !isSSR && useMediaQuery("(max-width: 767px)");
  const [open, setOpen] = useState(true);
  const [imageLoaded, setImageLoaded] = useState(false);

  const popupTheme = useMemo(() => (isMobile ? "bottomSheet" : "appearing"), [isMobile]);

  const redirectUrl = new URL("/generate-your-tour", getBaseUrl());

  const handleOnClick = () => {
    if (theme === "no-route") {
      sendEvent("track", "not_places_back_button");
    } else if (theme === "error") {
      sendEvent("track", "popup_error_back_button");
    }

    if (onClickPrev) {
      onClickPrev();
    } else if (theme === "error") {
      window.location.assign(redirectUrl.toString());
    }
  };

  const getContentByTheme = () => {
    switch (theme) {
      case "no-route":
        return {
          title: (
            <>
              <Trans>Not enough places found</Trans>
              <br />
              <Trans>to build a route</Trans>
            </>
          ),
          description: (
            <>
              <Trans>More urbanized area is needed to create</Trans>
              <br />
              <Trans>a personalized tour. Please try selecting a different location.</Trans>
            </>
          ),
        };
      case "error":
        return {
          title: <Trans>An error occurred</Trans>,
          description: <Trans>Please return to the previous step and try again</Trans>,
        };
      default:
        return {
          title: <Trans>Unexpected Error</Trans>,
          description: <Trans>Please try again later.</Trans>,
        };
    }
  };

  const { title, description } = getContentByTheme();

  return (
    <Popup hideHeader closable={false} open={open} theme={popupTheme} className="ErrorPopup">
      <div className="ErrorPopup__content">
        <div>
          <img
            src={places}
            className={`ErrorPopup__image ${imageLoaded ? "loaded" : ""}`}
            onLoad={() => setImageLoaded(true)}
          />
          <p className="ErrorPopup__title">{title}</p>
        </div>
        <div className="ErrorPopup__description">{description}</div>

        <Button theme="black" className="ErrorPopup__button" size="L" onClick={handleOnClick}>
          <Trans>Back</Trans>
        </Button>
      </div>
    </Popup>
  );
}
